<template lang="pug">
    d2-container
        el-form(:model="dataForm" :inline="true" size="mini" label-width="75px" label-position="right" label-suffix=":")
            div(style="display: flex; justify-content: space-between;")
                div
                   el-form-item(label="场地名称")
                        el-input.inputWidth(v-model="dataForm.name" clearable)
                   el-form-item(label="主办方")
                        el-input.inputWidth(v-model="dataForm.orgName" clearable)
                div
                    el-button(@click="queryList()" type="primary" icon="el-icon-search") 查 询
            el-row(style="padding-bottom: 15px;" :span="24")
                el-col(:md="23" :sm="5")
                    el-button(v-if="isAuth('')" type="primary" @click="addOrUpdateOpr()") 新建场地
        el-table(:data="tableData" style="width: 100%;" v-loading="dataListLoading" border)
            el-table-column(type="selection" header-align="center" align="center" width="50")
            el-table-column(prop="idNumber" header-align="center" align="center" label="场地ID")
            el-table-column(prop="name" header-align="center" align="center" label="场地名称")
            el-table-column(prop="typeLabels" header-align="center" align="center" label="场地属性")
            el-table-column(prop="memberTypeLabels" header-align="center" align="center" label="可定场会员类型")
            el-table-column(prop="orgName" header-align="center" align="center" label="主办方" )
            el-table-column(prop="thisWeekTotal" header-align="center" align="center" label="本周已定场数")
            el-table-column(prop="thisWeekTotalAmount" header-align="center" align="center" label="本周场地收入/元")
            el-table-column(prop="totalAmount" header-align="center" align="center" label="总场地收入/元")
            el-table-column(prop="statusLabel" header-align="center" align="center" label="状态")
            el-table-column(header-align="center" align="center" label="操作" width="100")
                template(slot-scope="scope")
                    el-menu.menuPonit(:collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style="color: #02B90D;")
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('')" @click="viewVisible = true; placeId = scope.row.id" ) 查看详情
                                el-menu-item(index="1-2" v-if="isAuth('')" @click="addOrUpdateOpr(scope.row.id)") 修改场地
                                el-menu-item(index="1-3" v-if="isAuth('')" @click="crewVisible = true; placeId = scope.row.id") 查看定场人员
                                el-menu-item(index="1-8" v-if="isAuth('') && scope.row.status === 1" @click="open_placeInfo_dialog(scope.row.id)") 发布场地
                                el-menu-item(index="1-4" v-if="isAuth('')" @click="resverDataVisible = true, placeId= scope.row.id") 定场管理
                                el-menu-item(index="1-5" v-if="isAuth('') && scope.row.status === 1" @click="offOrOnline('off', scope.row)" ) 下线场地
                                el-menu-item(index="1-6" v-if="isAuth('') && scope.row.status === 2" @click="offOrOnline('on', scope.row)" ) 上线场地
                                el-menu-item(index="1-7" v-if="isAuth('') && scope.row.status === 1 && scope.row.defaultFlag === 1" @click="setDefaultSite('cancel')") 取消默认场地
                                //- el-menu-item(index="1-8" v-if="isAuth('') && scope.row.status === 1 && scope.row.defaultFlag === 0" @click="setDefaultSite('set', scope.row.id)") 设为默认场地
        el-pagination(@size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper")
        AddOrUpdate(v-if="addOrUpdateVisible" :vaisible.sync="addOrUpdateVisible" :siteAttributesArray="siteAttributesArray" :memberTypeArray="memberTypeArray" :placeId="placeId" @refreshDataList="getDataList")
        SpotCrew(v-if="crewVisible" :vaisible.sync="crewVisible" :placeId="placeId")
        ReserveData(v-if="resverDataVisible" :vaisible.sync="resverDataVisible" :placeId="placeId")
        ViewInfo(v-if="viewVisible" :vaisible.sync="viewVisible" :placeId="placeId" :siteAttributesArray="siteAttributesArray" :memberTypeArray="memberTypeArray")
        placeInfo(ref="placeInfo_ref")
</template>

<script>
import AddOrUpdate from './add-or-update'
import SpotCrew from './spot-crew'
import ReserveData from './reserve-data'
import ViewInfo from './view-info'
import placeInfo from './place-info'
import { commomDictData } from '@/util/dictionary'

export default {
    name: 'reserveSite-site',
    components: {
        AddOrUpdate,
        SpotCrew,
        ReserveData,
        ViewInfo,
        placeInfo
    },
    data () {
        return {
            placeId: '',
            dataForm: {
                name: '',
                orgName: ''
            },
            dataListLoading: false,
            isCollapse: true,
            addOrUpdateVisible: false,
            crewVisible: false,
            resverDataVisible: false,
            viewVisible: false,
            tableData: [{
                type: 1,
                name: '鸟巢',
                statusLabel: '已下线',
                id: '123'
            }],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            memberTypeArray: [],
            siteAttributesArray: []
        }
  },
    created () {
        // 获取
        this.getDataList()
        this.getMemberTypeList()
        // 获取约场地属性列表(字典项)
        commomDictData('BOOK_PLACES_TYPE', this).then(res => {
            this.siteAttributesArray = res.list
        })
    },
    methods: {
        // 设置或取消默认场地
        setDefaultSite (oprType, id) {
            if (oprType === 'set') {
                // 设置为默认场地
                this.$http({
                    url: this.$http.adornUrl(`/bp-book-places/set-default/${id}`),
                    method: 'put',
                    data: {}
                })
                .then(data => {
                    this.$message.success(data.msg)
                    this.getDataList()
                })
            } else {
                // 取消默认场地
                this.$confirm(`请先选择新的默认场地，选择后，本场自动取消默认场地`, '提示', {
                    showCancelButton: false,
                    type: 'warning'
                })
                .then(() => {})
            }
        },
        // 新增或修改操作
        addOrUpdateOpr (id) {
            this.addOrUpdateVisible = true
            this.placeId = id
        },
        // 获取会员类型列表
        getMemberTypeList () {
            this.$http({
                url: this.$http.adornUrl('/bp-book-places/member-type-list'),
                method: 'get'
            })
            .then(res => {
                const { data } = res
                this.memberTypeArray = data
            })
        },
        // 预约场地列表分页查询
        getDataList () {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('/bp-book-places/page'),
                method: 'post',
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize
                }),
                data: this.dataForm
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.tableData = data.data.rows
                    this.totalPage = data.data.total
                } else {
                    this.tableData = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle (val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 按照条件查询
        queryList () {
            this.pageIndex = 1
            this.getDataList()
        },
        // 打开场地信息dialog
        open_placeInfo_dialog (placeId) {
            this.$refs.placeInfo_ref.init(placeId, this.siteAttributesArray)
        },
        // 场地上下线操作
        offOrOnline (status, row) {
            if (row.defaultFlag === 1) {
                return this.$message.error('该场地为默认场地，请重新选择默认场地后，方可下线该场地')
            }
            this.$confirm(`确定${(status === 'off' ? '下线' : '上线') + '【' + row.name + '】'}场地吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            )
            .then(() => {
                let apiUrl = ''
                if (status === 'off') {
                    // 下线
                    apiUrl = '/bp-book-places/down/' + row.id
                } else {
                    apiUrl = '/bp-book-places/up/' + row.id
                }
                this.$http({
                    // 上线
                    url: this.$http.adornUrl(`${apiUrl}`),
                    method: 'put'
                })
                .then(data => {
                    const { msg } = data
                    this.$message.success(msg)
                    this.getDataList()
                })
            })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '操作已取消'
                })
            })
        }
    }
}
</script>

<style scoped >
/* 操作三点 菜单样式 */
@import '../css/opr3dot.css';

.inputWidth {
  width: 210px;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

.el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}

.el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 24px;
  font-size: 12px;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
